import { Col, DatePicker, Form, Input, InputNumber, Row } from "antd";
import { useForm } from "antd/es/form/Form";
import React from "react";
import CTConfigurationService from "../../Services/CTConfigurationService";
import { adminContext } from "../../Common/PageRoute";
import dayjs from "dayjs";
import { Utils } from "../../Utilities/Utils";
import SAModal from "../../Common/Custom Components/Ant design/SAModal";

const AddAIAs = ({ id, record, onDismiss, isViewOnly = false }: any) => {
  const [form] = useForm();
  const { openNotification } = React.useContext(adminContext);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (id !== undefined && id !== null && id !== "") {
      form.setFieldsValue({
        name: record?.name,
        amount: record?.amount,
        fromDate: record?.fromDate ? dayjs(record?.fromDate) : undefined,
        toDate: record?.toDate ? dayjs(record?.toDate) : undefined,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  return (
    <SAModal
      footer={isViewOnly ? null : undefined}
      title={
        id
          ? "Edit annual investment allowance"
          : "Add annual investment allowance"
      }
      width={500}
      open={true}
      isLoading={loading}
      okText="Save"
      cancelText="Cancel"
      onCancel={() => onDismiss(false)}
      onOk={async () => {
        let Id = id === undefined || id === null ? "" : id;
        form.validateFields().then((values: any) => {
          setLoading(true);
          CTConfigurationService.addAIAsItem(values, Id).then((res) => {
            if (res.status) {
              setLoading(false);
              onDismiss(true);
            }
            else {
              openNotification(res.message);
              setLoading(false);
            }
          }).catch(() => setLoading(false));
        })
      }}
    >
      <Form disabled={isViewOnly} form={form} requiredMark={true}>
        <Row gutter={[8, 0]}>
          <Col xs={24} sm={12}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Name is required",
                },
                { validator: Utils.validateWhiteSpace }
              ]}
            >
              <Input
                className="line-height-28"
                placeholder="Name"
                style={{ height: 27 }}
                onKeyPress={(e) => Utils.ValidateCharSpaceAndNumberOnly(e)}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Amount"
              name="amount"
            >
              <InputNumber
                controls={false}
                placeholder="Amount"
                prefix="£"
                style={{ width: "100%", height: 27 }}
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="From date"
              name="fromDate"
            >
              <DatePicker
                style={{ width: "100%", height: 27 }}
                format='DD/MM/YYYY'
                className="line-height-28"
                placeholder="From date"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="To date"
              name="toDate"
            >
              <DatePicker
                style={{ width: "100%", height: 27 }}
                format='DD/MM/YYYY'
                className="line-height-28"
                placeholder="To date"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </SAModal>
  );
};

export default AddAIAs;
